import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import EmployeeDetails from './EmployeeDetails';
import AssetManagement from './AssetManagement';
import './AssetManagement.scss';
import '../../assets/scss/tables.scss';


function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const AssetManagementTabs = () => {
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ width: '100%' }} className='wh-table'>
            <div>
                <Box className='d-flex justify-content-start mb-3'>
                    <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" className='tabs-container-cls wh-tabs'>
                        <Tab label="Employee's List" disableRipple {...a11yProps(0)} />
                        <Tab label="Asset Management" disableRipple {...a11yProps(1)} />
                    </Tabs>
                </Box>
                <CustomTabPanel value={value} index={0}>
                    {/* Employee's List */}
                    <EmployeeDetails />
                </CustomTabPanel>
                <CustomTabPanel value={value} index={1}>
                    <AssetManagement />
                </CustomTabPanel>
            </div>
        </Box>
    );
}
export default AssetManagementTabs
